import { Component, HostListener, OnInit, ViewChild } from "@angular/core";
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { DialogPosition, MatDialog } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { APIFactoryEndPoints } from "src/app/common/apifactory-end-points";
import { LocalStorageService } from "src/app/common/LocalStorageService";
import { AdvanceSearchDTO } from "src/app/shared/models/advance-search-dto";
import { ProductGroupWithIdAndName } from "src/app/shared/models/productgroupwithidandname";
import { ProductSubGroupDtoWithIdName } from "src/app/shared/models/productsubgroupdtowithidname";
import { PinDialogService } from "src/app/shared/services/pin-dialog.service";
import { ToastService } from "src/app/shared/services/toastr.service";
import { environment } from "src/environments/environment";
import { getWindow } from "ssr-window";
import { Product } from "../../../../shared/models/product";
import { AuthService } from "../../../../shared/services/auth.service";
import { ProductService } from "../../../../shared/services/product.service";
import { PinDialogComponent } from "../pin-dialog/pin-dialog.component";
import { ProductFilterComponent } from "../product-filter/product-filter/product-filter.component";
import { MatrixDto } from "src/app/shared/models/matrix-dto";
import { ProductsWithWebOrderOffers } from "src/app/shared/models/productswithweborderoffers";
import { ProductDesignDialogComponent } from "../product-design-dialog/product-design-dialog.component";
import { HttpErrorResponse } from "@angular/common/http";
import { ProductsWithStock } from "src/app/shared/models/products-with-stock";
import { OfferDetailsDialogComponent } from "../offer-details-dialog/offer-details-dialog.component";
import { ViewOfferSetUpDto } from "src/app/shared/models/viewoffersetupdto";
import { OfferDialogComponent } from "../offer-dialog/offer-dialog.component";
import { BulkDiscountDto } from "src/app/shared/models/bulkdiscountdto";
import { Tax } from "src/app/shared/models/tax";
import { Cess } from "src/app/shared/models/cess";
import { FileService } from "src/app/common/File-Service";
import { ActivatedRoute, Router } from "@angular/router";
import { ProductSubGroup } from "src/app/shared/models/productsubgroup";
import { CdkVirtualScrollViewport } from "@angular/cdk/scrolling";
import { StorePickupDialogComponent } from "../store-pickup-dialog/store-pickup-dialog.component";
import { GoogleCustomer } from "src/app/shared/models/googlecustomer";
import { WebOrderStockDetailsDto } from "src/app/shared/models/web-order-stock-details-dto";
import { WebOrderMinimumDateTimeSetup } from "src/app/shared/models/weborderminimumdatetimesetup";
import { WebOrderLocationSetup } from "src/app/shared/models/weborderlocationsetup";
import moment from "moment";
import { AppConfigService } from "src/app/shared/services/app-config.service";
import { SEOService } from 'src/app/common/SEOService';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss'],
})
export class ProductListComponent implements OnInit {

  @ViewChild(CdkVirtualScrollViewport) viewport: CdkVirtualScrollViewport;

  matrixList: MatrixDto[] = [];
  allGroupList: ProductGroupWithIdAndName[] = [];
  allSubGroupList: ProductSubGroup[] = [];
  allProductList: Product[] = [];

  productList: Product[] = new Array(1200);
  loading = false;
  webUrl: string;
  brands = ['All', 'Apple', 'Realme', 'Nokia', 'Motorolla'];
  selectedBrand: 'All';

  searchForm: UntypedFormGroup;
  createSetUpForm: UntypedFormGroup;
  groupList: ProductGroupWithIdAndName[] = [];
  subGroupList: ProductSubGroupDtoWithIdName[] = [];
  show: boolean = false;
  subGroupShow: boolean = false;
  pincode: string;
  productWithOffers: ProductsWithWebOrderOffers[];

  page = 1; //demo
  pageNo: number = 0;

  selfLife: any;
  disbleBtn: boolean = false;
  advanceSearchData: AdvanceSearchDTO = new AdvanceSearchDTO();
  companyCode: number;
  designProducts: Product[] = [];
  productWithStock: ProductsWithStock[] = [];
  webOrderStockDetailsDto: WebOrderStockDetailsDto[] = [];

  groupClickId: number;
  subGroupClickId: number;

  productOffer: Product;
  discountOffer: number;
  bulkDiscountOffer: BulkDiscountDto;
  offerObj: any;

  serverUrl: string;
  currentUrl: string;
  sharingUrl: string;

  // FILTER //

  offerControl = new UntypedFormControl();
  locationCode: number;
  minPrice: number;
  maxPrice: number;
  minDiscRate: number;
  maxDiscRate: number;
  min: number;
  max: number;
  offer: any;
  offerTypeArray: string[] = [];
  flavoursArray: string[] = [];
  foodTypes: string[] = ["Veg", "Non-Veg"];
  taxList: Tax[] = [];
  cessList: Cess[] = [];
  resultProductList: Product[] = [];
  values: string[] = [];
  foodType: string[] = [];
  openfilter: boolean = false;
  searchBtnForDisc: boolean = true;
  cleatBtnDisc: boolean = false;
  radioStatus: boolean;
  checkedStatus: boolean;
  checkedValues: string[] = [];
  selectedValues: string[] = [];
  category: string;
  code: number[] = [];
  productCode: number[] = [];
  filter: string;
  deliveryType: string;
  googleCustomer: GoogleCustomer;
  webOrderMinimumDateTimeList: WebOrderMinimumDateTimeSetup = new WebOrderMinimumDateTimeSetup();
  storeLocation: WebOrderLocationSetup;
  timeSlot2: string[][] = [];
  timeSlotAvl: string[] = [];

  //Subscription
  private productSubcription: Subscription;
  private groupSubcription: Subscription;
  private subGroupSubscription: Subscription;
  private productSubscription: Subscription;
  private webOrderBestProductSubcription: Subscription;
  private offerSubscription: Subscription;
  private getDesignSubscription: Subscription;
  private checkAllowStockSubscription: Subscription;
  private stockSubscription: Subscription;
  private productOfferSubscription: Subscription;
  private productDiscountSubscription: Subscription;
  private productBulkDiscountSubscription: Subscription;
  private searchProductsByObjSub: Subscription;
  private getFoodTypeSubscription: Subscription;
  private productMinMaxPriceSubscription: Subscription;
  private promotionMasterSubscription: Subscription;
  private getTaxSubscription: Subscription;
  private getCessSubscription: Subscription;
  private webOrderMinimumDateTimeSubcription: Subscription;
  private webOrderTimeSlotSubcription: Subscription;

  constructor(
    private localStorage: LocalStorageService,
    public dialog: MatDialog,
    public authService: AuthService,
    private productService: ProductService,
    private toastrService: ToastService,
    private apiFactory: APIFactoryEndPoints,
    private formBuilder: UntypedFormBuilder,
    private pincodeDialogService: PinDialogService,
    private fileService: FileService,
    private route: ActivatedRoute,
    private navRoute: Router,
    private appConfig: AppConfigService,
    private seoService: SEOService
  ) {
    this.serverUrl = this.apiFactory.getServerUrl;
    this.locationCode = JSON.parse(this.localStorage.getItem('location_code'));
  }

  ngOnInit() {
    this.currentUrl = getWindow().location.hostname;
    try {
      const title = 'Products | 1 Bake Shop';
      const desc = 'Browse our range of cakes, pastries, snacks and more. Freshly baked and delivered to your door.';
      this.seoService.updateTitle(title);
      this.seoService.updateTags([
        { name: 'description', content: desc },
        { property: 'og:title', content: title },
        { property: 'og:description', content: desc },
        { property: 'og:url', content: getWindow().location.href }
      ]);
      this.seoService.setCanonicalURL();
    } catch (e) { }
    // set rel=prev / rel=next for paginated product lists when page query param present
    try {
      this.route.queryParams.subscribe(params => {
        const pageParam = Number(params['page'] || 1);
        const origin = getWindow().location.origin;
        const path = getWindow().location.pathname;
        const base = origin + path;
        // canonical without trailing page=1
        const canonical = pageParam > 1 ? `${base}?page=${pageParam}` : base;
        this.seoService.setCanonicalURL(canonical);
        // remove existing
        this.seoService.removeLinkRel('prev');
        this.seoService.removeLinkRel('next');
        if (pageParam > 1) {
          const prevUrl = `${base}?page=${pageParam - 1}`;
          this.seoService.addLinkRel('prev', prevUrl);
        }
        // set next to page+1 (only when paginated; conservative default)
        const nextUrl = `${base}?page=${pageParam + 1}`;
        this.seoService.addLinkRel('next', nextUrl);
      });
    } catch (e) { }
    try {
      const breadcrumb = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://1bakeshop.com/" },
          { "@type": "ListItem", "position": 2, "name": "Products", "item": "https://1bakeshop.com/products" }
        ]
      };
      this.seoService.addJSONLD(breadcrumb, 'breadcrumb-products');
    } catch (err) { }
    this.sharingUrl = getWindow().location.origin + '/product' + '/';
    this.webUrl = this.appConfig.setting.cartApiUrl;
    this.companyCode = JSON.parse(this.localStorage.getItem('company_code'));
    this.deliveryType = JSON.parse(this.localStorage.getItem("delivery_type"));
    this.googleCustomer = JSON.parse(this.localStorage.getItem("google_loggedIn_details"));
    this.storeLocation = JSON.parse(this.localStorage.getItem('pickup_location'));

    this.route.queryParams.subscribe(async params => {
      const hasCategory = 'category' in params;
      const hasCode = 'code' in params;
      const hasFilter = 'filter' in params;

      if (hasCategory || hasCode || hasFilter) {
        this.localStorage.removeItem('filterProductItems');
        await this.getAllProducts();
        this.category = params['category'];
        this.code = params['code'] ? params['code'].split(',').map(Number) : []; // Convert to an array of numbers
        this.filter = params['filter'];

        if (this.filter != 'offers') {
          this.filterProducts();
        }
      } else {
        this.getAllProducts();
      }
    });
  }

  filterProducts(): void {
    this.productList = this.allProductList;
    this.groupClickId = null;
    this.subGroupClickId = null;


    if (this.code.length > 0) {
      if (this.category == 'Group') {
        this.productList = this.productList.filter(product =>
          this.code.includes(product.productSubGroup.productGroup.refNo)
        );
      } else if (this.category == 'Matrix') {
        this.productList = this.productList.filter(product =>
          this.code.includes(product.productSubGroup.productGroup.productMatrix.refNo)
        );
      }
    }
    if (this.filter) {
      this.productCode.push(...this.productList.map(product => product.product_Code));
      this.productList = this.applyIndexFilter(this.filter);
    }
    this.matrixList.forEach(e => e.collapsed = (this.productList.map(p => p.productSubGroup.productGroup.productMatrix.refNo).includes(e.refNo)));
    this.selectedFilters.matrixGroups = [];
    this.selectedFilters.groupSubGroups = [];
    this.productList.forEach(p => {
      if (!this.selectedFilters.matrixGroups.map(m => m).includes(p.productSubGroup.productGroup.refNo)) {
        this.selectedFilters.matrixGroups.push(p.productSubGroup.productGroup.refNo);
      }
      if (!this.selectedFilters.groupSubGroups.map(g => g.refNo).includes(p.productSubGroup.refNo)) {
        this.selectedFilters.groupSubGroups.push(p.productSubGroup);
      }
    });
    this.selectedFilters.showClearAll = true;
  }

  applyIndexFilter(filter: string): any[] {
    switch (filter) {
      case 'under220':
        this.isCollapsed['price'] = !this.isCollapsed['price'];
        this.selectedFilters.cleatBtnPrice = true;
        this.selectedFilters.priceRange = { min: 1, max: 220 };
        this.searchForm.get('minValue').setValue(this.selectedFilters.priceRange.min);
        this.searchForm.get('maxValue').setValue(this.selectedFilters.priceRange.max);
        return this.productList.filter(product => product.net_Sale_Price <= 220 && product.productSubGroup.productGroup.productMatrix.refNo === 4);
      case 'under400':
        this.isCollapsed['price'] = !this.isCollapsed['price'];
        this.selectedFilters.cleatBtnPrice = true;
        this.selectedFilters.priceRange = { min: 1, max: 400 };
        this.searchForm.get('minValue').setValue(this.selectedFilters.priceRange.min);
        this.searchForm.get('maxValue').setValue(this.selectedFilters.priceRange.max);
        return this.productList.filter(product => product.net_Sale_Price <= 400 && product.productSubGroup.productGroup.productMatrix.refNo === 4);
      case 'combos':
        return this.productList.filter(product => product.productSubGroup.productGroup.productMatrix.refNo === 4 || product.productSubGroup.productGroup.productMatrix.refNo === 38);
      case 'partybox':
        return this.productList.filter(product => product.productSubGroup.productGroup.productMatrix.refNo === 70);
      case 'bulkbuy':
        return this.productList.filter(product => product.productSubGroup.productSubGroupName === 'Bulk Buy');
      case 'offers':
        return this.productList = this.allProductList.filter(product => this.productCode.includes(product.product_Code))
      default:
        return this.productList;
    }
  }

  async getMatrixList() {
    this.matrixList = await this.fileService.getFileDataAsync("matrixList");
    this.allGroupList = await this.fileService.getFileDataAsync("allGroupList");
    this.allProductList = await this.fileService.getFileDataAsync("allProductList");

    let matrixId: number = JSON.parse(this.localStorage.getItem("matrix_code"));
    let groupId: number = JSON.parse(this.localStorage.getItem("prod_group_code"));
    this.groupClickId = matrixId;
    this.subGroupClickId = groupId;

    if (groupId) {
      this.getGroupByMatrixCode(matrixId);
      this.onGroupSelect(groupId);
    } else if (matrixId) {
      this.onMatrixSelect(matrixId);
    } else {
      this.getWebOrderBestProductSetUpList();
    }

    // this.groupSubcription = this.productService.getMatrixList(this.currentUrl).subscribe((data) => {
    //   this.matrixList = data;
    // });
  }

  onMatrixSelect(matrixCode: number) {
    this.groupClickId = matrixCode;
    this.subGroupClickId = null;
    this.localStorage.setItem('matrix_code', JSON.stringify(matrixCode));
    this.localStorage.removeItem('prod_group_code');

    this.loading = true;
    this.productList = this.allProductList.filter(e => e.productSubGroup?.productGroup?.productMatrix?.refNo == matrixCode);
    this.show = true;
    this.loading = false;
    var Max = this.productList.map(p => +p.net_Sale_Price).reduce((a, b) => a > b ? a : b, 0);
    var Min = this.productList.map(p => +p.net_Sale_Price).reduce((a, b) => a < b ? a : b);
    this.searchForm.patchValue({ minValue: Min, maxValue: Max });
    this.getOfferDetails();

    // this.productSubscription = this.productService.getProductDetailsByMatrix(this.apiFactory.getProductDetailsByMatrixCode, matrixCode, this.currentUrl)
    //   .subscribe((data) => {
    //     this.productList = data;
    //     console.log(this.productList)
    //     this.productListForFilters = data;
    //     this.displayProduct = data;
    //     this.show = true;
    //     this.loading = false;
    //     var Max = this.productList.map(p => +p.net_Sale_Price).reduce((a, b) => a > b ? a : b, 0);
    //     var Min = this.productList.map(p => +p.net_Sale_Price).reduce((a, b) => a < b ? a : b);
    //     console.log(`Max: ${Max}`);
    //     console.log(`Min: ${Min}`);
    //     this.searchForm.patchValue({ minValue: Min, maxValue: Max });
    //     this.getOfferDetails();
    //   });

    this.getGroupByMatrixCode(matrixCode);
  }

  getGroupByMatrixCode(matrixCode: number) {
    this.groupList = this.allGroupList.filter(
      (e) => e.productMatrixCode == matrixCode
    );
    this.subGroupShow = true;

    // this.subGroupSubscription = this.productService.getGroupListByMatrix(this.apiFactory.getGroupDetailsByMatrix, this.currentUrl, matrixCode)
    //   .subscribe((data) => {
    //     this.groupList = data;
    //     this.subGroupShow = true;
    //   });
  }

  getGroupList() {
    this.selfLife = this.localStorage.getItem('min_selflife');
    let groupId: number = JSON.parse(
      this.localStorage.getItem('prod_group_code')
    );
    let subgroupId: number = JSON.parse(
      this.localStorage.getItem('prod_subgroup_code')
    );

    if (subgroupId != undefined) {
      this.getSubGroupByGroupCode(groupId);
      this.onSubGroupSelect(subgroupId);
    } else if (groupId != undefined) {
      this.onGroupSelect(groupId);
    } else {
      this.getWebOrderBestProductSetUpList();
    }

    this.groupSubcription = this.productService
      .getGroupList(this.currentUrl)
      .subscribe((data) => {
        this.groupList = data;
      });
  }

  onGroupSelect(prodGroupId: number) {
    this.subGroupClickId = prodGroupId;
    this.localStorage.setItem('prod_group_code', JSON.stringify(prodGroupId));
    this.localStorage.removeItem('prod_subgroup_code');

    this.loading = true;
    this.show = true;
    this.productList = this.allProductList.filter(e => e.productSubGroup.productGroup.refNo == prodGroupId);
    this.show = true;
    this.loading = false;
    var Max = this.productList.map(p => +p.net_Sale_Price).reduce((a, b) => a > b ? a : b, 0);
    var Min = this.productList.map(p => +p.net_Sale_Price).reduce((a, b) => a < b ? a : b);
    console.log(`Max: ${Max}`);
    console.log(`Min: ${Min}`);
    this.searchForm.patchValue({ minValue: Min, maxValue: Max });
    this.getOfferDetails();

    // this.productSubscription = this.productService.getProductDetailsBySubGroupCode(this.apiFactory.getProductDetailsByGroupCode, prodGroupId)
    //   .subscribe((data) => {
    //     this.productList = data;
    //     this.productListForFilters = data;
    //     this.displayProduct = data;
    //     this.show = true;
    //     this.loading = false;
    //     var Max = this.productList.map(p => +p.net_Sale_Price).reduce((a, b) => a > b ? a : b, 0);
    //     var Min = this.productList.map(p => +p.net_Sale_Price).reduce((a, b) => a < b ? a : b);
    //     console.log(`Max: ${Max}`);
    //     console.log(`Min: ${Min}`);
    //     this.searchForm.patchValue({ minValue: Min, maxValue: Max });
    //     this.getOfferDetails();
    //   });

    // this.getSubGroupByGroupCode(prodGroupId);
  }

  getSubGroupByGroupCode(prodGroupId: number) {
    this.subGroupSubscription = this.productService
      .getSubGroupDetailsByGroupCode(
        this.apiFactory.getSubGroupDetailsByGroupCode,
        prodGroupId
      )
      .subscribe((data) => {
        this.subGroupList = data;
        this.subGroupShow = true;
      });
  }

  onSubGroupSelect(prodSubGroupId: number) {
    this.localStorage.setItem(
      'prod_subgroup_code',
      JSON.stringify(prodSubGroupId)
    );

    this.loading = true;
    this.productSubscription = this.productService
      .getProductDetailsBySubGroupCode(
        this.apiFactory.getProductDetailsBySubGroupCode,
        prodSubGroupId
      )
      .subscribe((data) => {
        this.productList = data;
        this.show = true;
        this.loading = false;
        this.getOfferDetails();
      });
  }

  // getAllProducts() {
  //   this.loading = true;
  //   this.pageNo = this.pageNo + 1;
  //   this.productSubcription = this.productService
  //     .getProducts(this.pageNo)
  //     .subscribe((data) => {
  //       this.productList = data;
  //       this.productListForFilters = data;
  //       this.displayProduct = data;
  //       this.loading = false;
  //     });
  // }

  getWebOrderBestProductSetUpList() {
    this.webOrderBestProductSubcription = this.productService
      .getWebOrderBestProductSetup(
        this.apiFactory.getBestProducts,
        this.currentUrl
      )
      .subscribe((data) => {
        this.productList = data;
        this.show = true;
        this.loading = false;
        console.log(this.productList);
        // this.getOfferDetails();
      });
  }

  getOfferDetails() {
    let productId: number[] = this.allProductList.map(element => element.product_Code);
    if (productId.length === 0) return;

    let type = this.deliveryType ? (this.deliveryType === 'storePickup' ? 'Pickup' : 'Delivery') : null;

    const fetchOfferDetails = (locId: number) => {
      this.offerSubscription = this.productService.getOfferDetails(this.apiFactory.getOfferDetails, locId, productId, this.currentUrl)
        .subscribe((data: any) => {
          this.processOfferDetails(data);
        });
    };

    if (!type) {
      fetchOfferDetails(0);
      return;
    }

    this.offerSubscription = this.productService.getOfferAllowFor(this.apiFactory.getOfferAllowFor, this.currentUrl, type)
      .subscribe((response: any) => {
        if (response.data === 'Not Available') {
          console.log("No offers available.");
          return;
        }

        let locId = 0;
        if (response.data === 'allowForWebsite') {
          locId = this.googleCustomer?.locationCode || 0;
        } else if (response.data === 'allowForLocation') {
          locId = JSON.parse(this.localStorage.getItem('location_code')) || 0;
        }
        fetchOfferDetails(locId);
      });
  }

  processOfferDetails(data: any) {
    this.productWithOffers = data;
    console.log(this.productWithOffers);

    this.offerTypeArray = [];

    if (this.productWithOffers.length > 0) {
      this.productWithOffers.forEach(element => {
        element.offerDetails.forEach(offerDetails => {
          if (!this.offerTypeArray.includes(offerDetails.schemeType)) {
            this.offerTypeArray.push(offerDetails.schemeType);
          }
        });
      });
    }

    [this.allProductList, this.productList].forEach(productList => {
      productList.forEach(element => {
        let arr = this.productWithOffers.filter(offer => offer.productCode === element.product_Code);
        if (arr.length !== 0) {
          element.offerDetails = arr[0].offerDetails;
          element.offers = arr[0].offers;
        }
      });
    });

    if (this.filter === 'offers') {
      this.isCollapsed['offer'] = !this.isCollapsed['offer'];
      this.selectedFilters.offers = ['Buy X get Y Free'];
      this.productList = this.allProductList.filter(product =>
        product.offerDetails?.some(offerDetails => offerDetails.schemeType === 'Buy X get Y Free')
      );
      this.productCode = this.productList.map(product => product.product_Code);
      if (this.category) {
        this.filterProducts();
      }

    }
    if (!this.filter && this.selectedFilters.offers.length > 0) {
      this.applyFilters();
      this.expandAndCollapseAllFilters();
    }
    console.log(this.productList);
  }

  specialProductCodes: number[] = [901, 902, 743, 744, 746, 747, 745, 742];
  addFavourite(product: Product) {
    if (this.specialProductCodes.includes(Number(product.product_Code))) {
      this.toastrService.showWarningToast('Coming soon.');
      return;
    }
    const a: Product[] = JSON.parse(this.localStorage.getItem('avf_item')) || [];
    product.cartProductType = 'Product';
    this.productService.addFavouriteProduct(product);
  }

  addToCart(product: Product, goToCartPage: boolean) {
    console.log(product);
    if (this.specialProductCodes.includes(Number(product.product_Code))) {
      this.toastrService.showWarningToast('Coming soon.');
      return;
    }
    this.openDeliveryTypeDialog(product, goToCartPage);
  }

  openDeliveryTypeDialog(product: Product, goToCartPage: boolean) {
    let deliveryType = JSON.parse(this.localStorage.getItem('delivery_type'));
    let locId = JSON.parse(this.localStorage.getItem('location_code'));
    console.log('Delivery Type:', deliveryType, 'Location ID:', locId);
    if (!deliveryType || !locId) {
      const dialogRef = this.dialog.open(StorePickupDialogComponent, {
        width: '300px',
        autoFocus: false,
        panelClass: 'store-dialog-container'
      });

      dialogRef.afterClosed().subscribe(async result => {
        console.log(result)
        if (result) {
          await this.getProductDeliveryTimeAndStockDetails(); // wait for API to update productList
          const updatedProduct = this.productList.find(p => p.product_Code === product.product_Code);
          if (result === 'storePickup') {
            this.setStorePickup(updatedProduct, goToCartPage);
          } else if (result === 'delivery') {
            this.setDelivery(updatedProduct, goToCartPage);
            // this.openPinDialog(product, goToCartPage);
          }
        }
      });
    } else {
      if (deliveryType === 'storePickup') {
        this.setStorePickup(product, goToCartPage);
      } else if (deliveryType === 'delivery') {
        this.setDelivery(product, goToCartPage);
        // this.openPinDialog(product, goToCartPage);
      }
    }
  }

  setStorePickup(product: Product, goToCartPage: boolean) {
    let selfLife = JSON.parse(this.localStorage.getItem('min_selflife'));
    if (product.shelf_Life_In_Hours >= selfLife) {
      product.cartProductType = 'Product';
      this.getProductWithStock(product, goToCartPage);
    } else {
      this.toastrService.showErrorToast("Cannot add to cart, shelf life is under " + selfLife + " hours.");
    }
  }

  setDelivery(product: Product, goToCartPage: boolean) {
    let selfLife = JSON.parse(this.localStorage.getItem("min_selflife"));
    if (product.shelf_Life_In_Hours >= selfLife) {
      product.cartProductType = "Product";
      this.getProductWithStock(product, goToCartPage);
    } else {
      this.toastrService.showErrorToast("Cannot add to cart, shelf life is under " + selfLife + " hours.");
    }
  }

  openPinDialog(product: Product, goToCartPage: boolean) {
    this.pincode = this.localStorage.getItem('pincode_item');
    console.log(product);

    if (this.pincode == null) {
      const dialogRef = this.dialog.open(PinDialogComponent, {
        width: '300px',
        // data: product,
        panelClass: 'pin-dialog-container',
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result?.result == true) {
          // this.getGroupList();
          let selfLife = JSON.parse(this.localStorage.getItem('min_selflife'));
          if (product.shelf_Life_In_Hours >= selfLife) {
            product.cartProductType = 'Product';
            // this.productService.addToCart(product);
            // this.getDesignBySubGroupAndUrl(product);
            this.getProductWithStock(product, goToCartPage);
          } else {
            this.toastrService.showErrorToast("Cannot add to cart, shelf life is under " + selfLife + " hours.");
          }
          this.getOfferDetails();
        }
      });
    } else {
      // this.getGroupList();
      let selfLife = JSON.parse(this.localStorage.getItem('min_selflife'));
      if (product.shelf_Life_In_Hours >= selfLife) {
        product.cartProductType = 'Product';
        // this.productService.addToCart(product);
        // this.getDesignBySubGroupAndUrl(product);
        this.getProductWithStock(product, goToCartPage);
      } else {
        this.toastrService.showErrorToast("Cannot add to cart, shelf life is under " + selfLife + " hours.");
      }
    }
  }

  getProductWithStock(product: Product, goToCartPage: boolean) {
    if (this.checkAllowStockSubscription) return;

    const locId = JSON.parse(this.localStorage.getItem('location_code'));
    const deliveryType = JSON.parse(this.localStorage.getItem("delivery_type")) ?? 'delivery';

    if (!locId) {
      this.toastrService.showErrorToast("Location can't place order");
      return;
    }

    this.checkAllowStockSubscription = this.productService
      .getSystemAndManualStockDetails(this.apiFactory.getSystemAndManualStockDetails, locId, [product.product_Code], this.currentUrl, deliveryType)
      .subscribe({
        next: (data: WebOrderStockDetailsDto[]) => {
          this.checkAllowStockSubscription = null;

          const stockData = data?.[0]; // Get the stock data for this single product

          if (!stockData) {
            this.toastrService.showErrorToast(`${product.product_Name} stock data not found.`);
            return;
          }

          const minQty = product.minimum_Order_Quantity || 0;

          // Check Manual Stock first
          if (stockData.manualStockAllow) {
            if (stockData.manualStock < minQty) {
              this.toastrService.showErrorToast(`${product.product_Name} is out of stock, available: ${stockData.manualStock}`);
              return;
            }
            this.getDesignBySubGroupAndUrl(product, goToCartPage);
            return;
          }

          // Then check System Stock
          if (stockData.systemStockAllow) {
            if (stockData.systemStock < minQty) {
              this.toastrService.showErrorToast(`${product.product_Name} is out of stock, available: ${stockData.systemStock}`);
              return;
            }
            this.getDesignBySubGroupAndUrl(product, goToCartPage);
            return;
          }

          // If neither manual nor system stock check is allowed, proceed anyway
          this.getDesignBySubGroupAndUrl(product, goToCartPage);
        },
        error: (error: HttpErrorResponse) => {
          this.checkAllowStockSubscription = null;
          this.toastrService.showErrorToast('Something went wrong while checking stock.');
        }
      });
  }

  getProductWithStock1(product: Product, goToCartPage: boolean) {
    if (this.checkAllowStockSubscription) return;

    let locId = JSON.parse(this.localStorage.getItem('location_code'));
    if (locId) {
      this.checkAllowStockSubscription = this.productService.checkAllowStockByLocAndUrl(this.apiFactory.checkAllowStockByLocAndUrl, locId, this.currentUrl)
        .subscribe((response: any) => {
          this.checkAllowStockSubscription = null;
          if (response.data) {
            if (product.product_Code) {
              this.stockSubscription = this.productService.getStockDetails(this.apiFactory.getStockDetails, [product.product_Code], locId)
                .subscribe((data: any) => {
                  this.productWithStock = data;
                  var arr = this.productWithStock.filter((p) => p.product_Code == product.product_Code);
                  if (arr.length != 0) {
                    product.systemStock = arr[0].systemStock;
                  }
                  if (product.cartProductType == 'Product' && product.minimum_Order_Quantity > product.systemStock) {
                    this.toastrService.showErrorToast(product.product_Name + ' is out of stock, stock available ' + product.systemStock);
                    return;
                  }
                  this.getDesignBySubGroupAndUrl(product, goToCartPage);
                },
                  (error: HttpErrorResponse) => {
                    this.toastrService.showErrorToast('Something wrong..');
                  }
                );
            } else {
            }
          } else {
            this.getDesignBySubGroupAndUrl(product, goToCartPage);
          }
        },
          (error: HttpErrorResponse) => {
            this.toastrService.showErrorToast('Something wrong..');
          }
        );
    } else {
      this.toastrService.showErrorToast("Location can't place order");
    }
  }

  getDesignBySubGroupAndUrl(product: Product, goToCartPage: boolean) {
    const cartProducts: Product[] = JSON.parse(this.localStorage.getItem('avct_item')) || [];
    if (cartProducts.some((temp) => temp.product_Code == product.product_Code)) {
      if (goToCartPage) {
        this.productService.navigateToCart(product);
      }
      else {
        this.toastrService.showErrorToast(product.product_Name + ' is already added to cart');
        return;
      }
    }
    this.getDesignSubscription = this.productService.getWebOrderDesigns(this.apiFactory.getWebOrderDesignBySubgroupAndUrl, product.productSubGroup.refNo, this.currentUrl)
      .subscribe((data) => {
        console.log(data);
        if (data.length > 0) {
          this.designProducts = data;
          const cartProducts: Product[] = JSON.parse(this.localStorage.getItem('avct_item')) || [];
          let designIndex = cartProducts.findIndex((e) => e.designForProductCode === product.product_Code);
          if (designIndex >= 0) {
            this.designProducts.map((e) => (e.is_Default = false));
            this.designProducts.filter((item) => item.product_Code == cartProducts[designIndex].product_Code).map((e) => (e.is_Default = true));
          }
          this.openDesignDialog(product, this.designProducts, goToCartPage);
        } else {
          if (product.offerDetails?.length > 0)
            this.openOfferDialog(product, null, goToCartPage);
          else {
            this.productService.addToCart(product);

            if (goToCartPage) {
              this.productService.navigateToCart(product);
            }
          }
          // this.toastrService.showErrorToast('No design available');
        }
      });
  }

  openDesignDialog(product: Product, designProducts: Product[], goToCartPage: boolean) {
    document.body.classList.add('dialog-open');
    const dialogRef = this.dialog.open(ProductDesignDialogComponent, {
      width: '430px',
      height: '410px',
      maxWidth: '90vw',
      autoFocus: false,
      data: designProducts,
      panelClass: 'custom-dialog-container',
    });

    dialogRef.afterClosed().subscribe((result) => {
      document.body.classList.remove('dialog-open');
      if (result) {
        console.log(result.data);
        console.log(result.noDesign);
        if (result?.data) {
          let design: Product = result?.data;
          design.designForProductCode = product.product_Code;
          design.cartProductType = 'Product';
          if (product.offerDetails?.length > 0)
            this.openOfferDialog(product, design, goToCartPage);
          else {
            this.productService.addToCartDesign(product, design);

            if (goToCartPage) {
              this.productService.navigateToCart(product);
            }
          }
        } else if (result?.noDesign) {
          if (product.offerDetails?.length > 0)
            this.openOfferDialog(product, null, goToCartPage);
          else {
            this.productService.addToCart(product);

            if (goToCartPage) {
              this.productService.navigateToCart(product);
            }
          }
        }
      }
    });
  }

  openOfferDialog(product: Product, design: Product, goToCartPage: boolean) {
    console.log(product);
    const cartProducts: Product[] = JSON.parse(this.localStorage.getItem('avct_item')) || [];
    if (cartProducts.some((temp) => temp.product_Code == product.product_Code)) {
      if (goToCartPage) {
        this.productService.navigateToCart(product);
      }
      else {
        this.toastrService.showErrorToast(product.product_Name + ' is already added to cart');
        return;
      }
    }
    let offers: ViewOfferSetUpDto[] = product.offerDetails;
    let appliedOfferId: string = product.offerId
      ? product.offerId
      : product.offerDetails[0].offerId;
    const dialogRef = this.dialog.open(OfferDialogComponent, {
      width: '500px',
      height: '300px',
      data: { offers, appliedOfferId },
    });

    dialogRef.afterClosed().subscribe((offerObj) => {
      console.log(offerObj);
      if (offerObj) {
        this.offerObj = offerObj;
        //conditions
        var orderQuantity;
        var freeByProductCode;
        var cartProductType;

        if (product) {
          product.orderQuantity = Math.max(offerObj.minQty, offerObj.buyQty);
          // product.orderQuantity = offerObj.minQty;
          orderQuantity = product.orderQuantity;
          freeByProductCode = product.product_Code;
          cartProductType = product.cartProductType;
          if (product.cartProductType == 'Product') {
            product.basePremiumFlavourPrice = 0;
            product.premiumFlavourPrice = 0;
          }
        }
        console.log(product);

        // if (design) {
        //   this.productService.addToCartDesign(product, design);
        // }
        // else if (product.offerDetails[0].minQty > 1) {
        //   this.productService.addToCart(product);
        // }

        if (offerObj.schemeType == 'Buy 1 get 1 Free' || offerObj.schemeType == 'Buy X get Y Free') {
          this.productOfferSubscription = this.productService.getProductOfferDetails(this.apiFactory.productOfferDetails, offerObj.offerId, orderQuantity)
            .subscribe(
              (data) => {
                // offer processing
                this.productOffer = data;
                //set order qty as product QTY IN CART
                this.productOffer.product_Name = this.productOffer.product_Name.concat('(').concat(offerObj.schemeType).concat(')');
                const freeQty = Math.floor(orderQuantity / offerObj.buyQty) * offerObj.getQty;
                this.productOffer.orderQuantity = freeQty;
                // this.productOffer.orderQuantity = orderQuantity;
                this.productOffer.minimum_Order_Quantity = offerObj.minQty;
                // this.productOffer.net_Sale_Price = offerObj.productPriceForCustomer;
                this.productOffer.sale_Price = Number((this.productOffer.priceForCustomer / (1 + (this.productOffer.tax.taxRate / 100) + (this.productOffer.cess.cessRate / 100))));
                this.productOffer.discountAmt = 0;
                this.productOffer.discountRate = 0;
                var taxableAmt = this.productOffer.sale_Price - ((this.productOffer.sale_Price * this.productOffer.discountRate) / 100);
                var cess = this.productOffer.cess.cessRate;
                var tax = this.productOffer.tax.taxRate;
                var cessAmt = (cess / 100) * taxableAmt;
                var cgst = (this.productOffer.tax.taxRate / 2 / 100) * taxableAmt;
                var sgst = (this.productOffer.tax.taxRate / 2 / 100) * taxableAmt;
                var tot = cgst + sgst;
                this.productOffer.taxAmount = tot;
                this.productOffer.cgstAmt = cgst;
                this.productOffer.sgstAmt = sgst;
                this.productOffer.cessAmount = cessAmt;
                this.productOffer.net_Sale_Price = taxableAmt + tot + cessAmt;
                this.productOffer.cessRate = cess;
                this.productOffer.taxRate = tax;
                this.productOffer.freeProductNetSalePrice = offerObj.netSalePrice;
                this.productOffer.freeByProductCode = freeByProductCode;
                this.productOffer.cartProductType = cartProductType;
                this.productOffer.product_Type = this.productOffer.product_Type;
                this.productOffer.product_Unit = this.productOffer.product_Unit;
                this.productOffer.food_Type = this.productOffer.food_Type;
                this.productOffer.hsn_Code = this.productOffer.hsn_Code;
                this.productOffer.deliveryDate = product.deliveryDate;
                this.productOffer.timeSlotAvl = product.timeSlotAvl;
                this.productOffer.deliveryTime = product.deliveryTime;
                this.productOffer.deliveryLabel = product.deliveryLabel;

                // main product tax and net amount calculations
                product.discountAmt = 0;
                product.discountRate = 0;
                var taxableAmt = product.sale_Price - (product.sale_Price * 0) / 100;
                taxableAmt = taxableAmt + product.basePremiumFlavourPrice;
                var cess = product.cess.cessRate;
                var cessAmt = (cess / 100) * taxableAmt;
                var cgst = (product.tax.taxRate / 2 / 100) * taxableAmt;
                var sgst = (product.tax.taxRate / 2 / 100) * taxableAmt;
                var tot = cgst + sgst;
                product.promotionOfferId = offerObj.offerId;
                product.offerId = offerObj.offerId;
                product.taxAmount = tot; //Tax Amount
                product.cgstAmt = cgst;
                product.sgstAmt = sgst;
                product.cessAmount = cessAmt;
                product.net_Sale_Price = taxableAmt + tot + cessAmt;
                console.log(product);
                console.log(this.productOffer);
                this.productService.addToCartWithOffer(product, this.productOffer, design);

                if (goToCartPage) {
                  this.productService.navigateToCart(product);
                }
              },
              (err) => {
                if (err.error) {
                  this.toastrService.showErrorToast(err.error.message);
                }
              }
            );
        } else {
          if (offerObj.schemeType == 'Buy x get x percent off') {
            this.productDiscountSubscription = this.productService
              .getProductDiscountDetails(
                this.apiFactory.productDiscountDetails,
                offerObj.offerId,
                orderQuantity
              )
              .subscribe(
                (data) => {
                  console.log(data);
                  this.discountOffer = data;
                  product.discountAmt =
                    (this.discountOffer / 100) * product.sale_Price;
                  product.discountRate = this.discountOffer;
                  var taxableAmt =
                    product.sale_Price -
                    (product.sale_Price * this.discountOffer) / 100;
                  taxableAmt = taxableAmt + product.basePremiumFlavourPrice;
                  var cess = product.cess.cessRate;
                  var cessAmt = (cess / 100) * taxableAmt;
                  var cgst = (product.tax.taxRate / 2 / 100) * taxableAmt;
                  var sgst = (product.tax.taxRate / 2 / 100) * taxableAmt;
                  var tot = cgst + sgst;
                  product.promotionOfferId = offerObj.offerId;
                  product.offerId = offerObj.offerId;
                  product.taxAmount = tot; //Tax Amount
                  product.cgstAmt = cgst;
                  product.sgstAmt = sgst;
                  product.cessAmount = cessAmt;
                  product.net_Sale_Price = taxableAmt + tot + cessAmt;
                  this.productService.addToCartWithOffer(product, null, design);

                  if (goToCartPage) {
                    this.productService.navigateToCart(product);
                  }
                },
                (err) => {
                  if (err.error) {
                    this.toastrService.showErrorToast(err.error.message);
                  }
                }
              );
          } else {
            this.productBulkDiscountSubscription = this.productService
              .getProductBulkDiscountDetails(
                this.apiFactory.productBulkOfferDetails,
                offerObj.offerId
              )
              .subscribe((data) => {
                this.bulkDiscountOffer = data;
                product.discountAmt =
                  (this.bulkDiscountOffer.discount / 100) * product.sale_Price;
                product.discountRate = this.bulkDiscountOffer.discount;
                var taxableAmt =
                  product.sale_Price -
                  (product.sale_Price * this.bulkDiscountOffer.discount) / 100;
                taxableAmt = taxableAmt + product.basePremiumFlavourPrice;
                var cess = product.cess.cessRate;
                var cessAmt = (cess / 100) * taxableAmt;
                var cgst = (product.tax.taxRate / 2 / 100) * taxableAmt;
                var sgst = (product.tax.taxRate / 2 / 100) * taxableAmt;
                var tot = cgst + sgst;
                product.promotionOfferId = offerObj.offerId;
                product.offerId = offerObj.offerId;
                product.taxAmount = tot; //Tax Amount
                product.cgstAmt = cgst;
                product.sgstAmt = sgst;
                product.cessAmount = cessAmt;
                product.net_Sale_Price = taxableAmt + tot + cessAmt;
                this.productService.addToCartWithOffer(product, null, design);

                if (goToCartPage) {
                  this.productService.navigateToCart(product);
                }
              });
          }
        }

      } else {
        // if (design)
        //   this.productService.addToCartDesign(product, design);
        // else
        //   this.productService.addToCart(product);
      }
    });
  }

  // openPinDialog() {
  //   this.pincode = this.localStorage.getItem("pincode_item");

  //   if (this.pincode == null) {
  //     const dialogRef = this.dialog.open(PinDialogComponent, {
  //       width: "300px",
  //       // data: product,
  //       panelClass: "pin-dialog-container",
  //     });

  //     dialogRef.afterClosed().subscribe((result) => {
  //       if (result?.result == true) {
  //         this.getGroupList();
  //       }
  //     });
  //   } else {
  //     this.getGroupList();
  //   }
  // }

  openFilterDialog(): void {
    this.advanceSearchData.module = 'WebProduct';

    const dialogPosition: DialogPosition = {
      top: '250px',
      right: '0px',
    };
    const dialogRef = this.dialog.open(ProductFilterComponent, {
      width: '220px',
      position: dialogPosition,
      data: {
        advSearchInput: this.advanceSearchData,
        disbleBtn: this.disbleBtn,
      },
      panelClass: 'custom-container',
    });

    dialogRef.afterClosed().subscribe((data) => {
      console.log(data);
      if (data) {
        let list = data.resultProductList;
        if (list.length >= 0) {
          this.productList = list;
          this.getOfferDetails();
        }
        this.disbleBtn = data.disbleBtn;

        this.advanceSearchData = data.advSearchInput;
      }
    });
  }

  openDialog(product: Product) {
    this.pincode = this.localStorage.getItem('pincode_item');

    if (this.pincode == null) {
      const dialogRef = this.dialog.open(PinDialogComponent, {
        width: '300px',
        data: product,
        panelClass: 'pin-dialog-container',
      });

      dialogRef.afterClosed().subscribe((result) => {
        console.log('The dialog was closed');
      });
    } else {
      this.addToCart(product, false);
    }
  }

  viewOfferDetail(offers: ViewOfferSetUpDto[]) {
    console.log(offers);
    let dialogRef = this.dialog.open(OfferDetailsDialogComponent, {
      width: '550px',
      minHeight: '18%',
      maxWidth: '90%',
      maxHeight: '70%',
      autoFocus: false,
      data: { offerData: offers },
    });

    dialogRef.afterClosed().subscribe((res) => { });
  }

  onShareClick(product: Product) {
    var url = 'https://web.whatsapp.com/send';
    var text =
      getWindow().location.origin + '/product' + '/' + product.product_Code;
    console.log(text);
    window.open(url + '?text=' + text);
  }

  getFoodType() {
    this.getFoodTypeSubscription = this.productService
      .getMinMaxPrice(this.apiFactory.getFoodType)
      .subscribe((data) => {
        if (data.length > 0) {
          this.foodTypes = data;
        }
      });
  }

  getAllTax() {
    this.getTaxSubscription = this.productService
      .getMinMaxPrice(this.apiFactory.getAllTax)
      .subscribe((data) => {
        if (data.length > 0) {
          this.taxList = data;
        }
      });
  }

  getAllCess() {
    this.getCessSubscription = this.productService
      .getMinMaxPrice(this.apiFactory.getAllCess)
      .subscribe((data) => {
        if (data.length > 0) {
          this.cessList = data;
        }
      });
  }

  //  FILTER   //
  selectedFilters = {
    priceRange: { min: 0, max: 1000 },
    flavours: [],
    foodTypes: [],
    offers: [],
    matrixGroups: [],
    groupSubGroups: [],
    showClearAll: false,
    cleatBtnPrice: false
  };

  isCollapsed = {
    price: true,
    flavour: true,
    foodType: true,
    offer: true
  };
  activeSort: string = '';

  async getAllProducts() {
    this.matrixList = await this.fileService.getFileDataAsync("matrixList");
    this.allGroupList = await this.fileService.getFileDataAsync("allGroupList");
    this.allProductList = await this.fileService.getFileDataAsync("allProductList");
    this.matrixList.forEach(e => e.groupList = this.allGroupList.filter((f) => f.productMatrixCode == e.refNo));
    this.allProductList.forEach(element => {
      if (!this.allSubGroupList.some(e => e.refNo == element.productSubGroup.refNo)) {
        this.allSubGroupList.push(element.productSubGroup)
      }
      element.imageUrl = 'assets/img/' + element.product_Picture + '?ud=' + Date.now();
    });
    this.productList = this.allProductList;
    this.max = this.productList.map(p => +p.net_Sale_Price).reduce((a, b) => a > b ? a : b, 0);
    this.min = this.productList.map(p => +p.net_Sale_Price).reduce((a, b) => a < b ? a : b);
    this.show = true;
    this.selectedFilters.priceRange = { min: this.min, max: this.max };
    this.searchFormSetUp();
    this.getOfferDetails();
    this.getProductDeliveryTimeAndStockDetails();
    this.setLocalStorageData();
    this.setGlobalMinMax();
  }

  setLocalStorageData() {
    if (this.localStorage.getItem('filterProductItems')) {
      this.selectedFilters = JSON.parse(this.localStorage.getItem('filterProductItems'));
      this.searchForm.patchValue({ minValue: this.selectedFilters.priceRange.min, maxValue: this.selectedFilters.priceRange.max });
      if (this.selectedFilters.offers.length == 0) {
        this.applyFilters();
        this.expandAndCollapseAllFilters();
      }
    }
  }

  expandAndCollapseAllFilters() {
    if (this.selectedFilters.showClearAll) {
      this.selectedFilters.flavours.length > 0 ? this.toggleSection('flavour') : '';
      this.selectedFilters.foodTypes.length > 0 ? this.toggleSection('foodType') : '';
      this.selectedFilters.offers.length > 0 ? this.toggleSection('offer') : '';
      this.selectedFilters.priceRange.min != this.min || this.selectedFilters.priceRange.max != this.max ? this.toggleSection('price') : '';
      if (this.selectedFilters.groupSubGroups.length > 0)
        this.matrixList.forEach(e => e.collapsed = this.selectedFilters.groupSubGroups.some(f => f.productGroup.productMatrix.refNo == e.refNo));
    } else {
      this.isCollapsed.price = true;
      this.isCollapsed.flavour = true;
      this.isCollapsed.foodType = true;
      this.isCollapsed.offer = true;
      this.matrixList.forEach(e => e.collapsed = false);
    }
  }

  searchFormSetUp() {
    this.searchForm = this.formBuilder.group({
      minValue: [this.min],
      maxValue: [this.max]
    });
  }

  onFilterChange(type: string, value: string, event: any) {
    if (event.target.checked) {
      this.selectedFilters[type].push(value);
    } else {
      const index = this.selectedFilters[type].indexOf(value);
      if (index > -1) {
        this.selectedFilters[type].splice(index, 1);
      }
    }
    this.applyFilters();
  }

  validateMinMax(value: string, type: string) {
    if (type === 'min' && +value > +this.searchForm.get('maxValue').value) {
      this.searchForm.get('minValue').setValue(+this.searchForm.get('maxValue').value - 1);
    } else if (type === 'max' && +value < +this.searchForm.get('minValue').value) {
      this.searchForm.get('maxValue').setValue(+this.searchForm.get('minValue').value + 1);
    }
    this.selectedFilters.cleatBtnPrice = false;
  }

  validate(callOrigin: string, key: string) {
    if (callOrigin === 'price') {
      if (Number.parseInt(this.searchForm.get('minValue').value) > Number.parseInt(key)) {
        key = (Number.parseInt(this.searchForm.get('minValue').value) + 1).toString();
        this.searchForm.get('maxValue').setValue(key);
      }
    }
  }

  applyPriceInput(type: string) {
    if (type === 'price') {
      this.selectedFilters.priceRange.min = this.searchForm.get('minValue').value;
      this.selectedFilters.priceRange.max = this.searchForm.get('maxValue').value;
      this.selectedFilters.cleatBtnPrice = true;
      this.applyFilters();
    }
  }

  clearPriceInput() {
    this.searchForm.get('minValue').reset();
    this.searchForm.get('maxValue').reset();
    this.selectedFilters.cleatBtnPrice = false;
    this.searchForm.patchValue({ minValue: this.min, maxValue: this.max });
    this.selectedFilters.priceRange = { min: this.min, max: this.max };
    this.applyFilters();
  }

  onOfferCheckBoxClick(event: boolean, value: string) {
    if (event) {
      this.selectedFilters.offers.push(value);
    } else {
      const index = this.selectedFilters.offers.indexOf(value);
      if (index > -1) {
        this.selectedFilters.offers.splice(index, 1);
      }
      this.removeRelatedGroups(value);
    }
    this.applyFilters();
  }

  removeRelatedGroups(value: string) {
    const affectedProducts = this.allProductList.filter(product =>
      product.offerDetails?.some(offerDetails => offerDetails.schemeType === value)
    );

    const affectedGroups = new Set(affectedProducts.map(p => p.productSubGroup.productGroup.refNo));
    const affectedSubGroups = new Set(affectedProducts.map(p => p.productSubGroup.refNo));

    this.selectedFilters.matrixGroups = this.selectedFilters.matrixGroups.filter(g => !affectedGroups.has(g));
    this.selectedFilters.groupSubGroups = this.selectedFilters.groupSubGroups.filter(g => !affectedSubGroups.has(g.refNo));
  }

  onFoodTypeCheckBoxClick(event: boolean, value: string) {
    if (event) {
      this.selectedFilters.foodTypes.push(value);
    } else {
      const index = this.selectedFilters.foodTypes.indexOf(value);
      if (index > -1) {
        this.selectedFilters.foodTypes.splice(index, 1);
      }
    }
    this.applyFilters();
  }

  onGroupChange(event: boolean, groupCode: number) {
    if (event) {
      this.selectedFilters.matrixGroups.push(groupCode);
    } else {
      const index = this.selectedFilters.matrixGroups.indexOf(groupCode);
      if (index > -1) {
        this.selectedFilters.matrixGroups.splice(index, 1);
      }
    }
    let existingSubGroups = this.selectedFilters.groupSubGroups.map(obj => obj.refNo);
    this.selectedFilters.groupSubGroups = this.allSubGroupList.filter(
      f => this.selectedFilters.matrixGroups.includes(f.productGroup.refNo) && (f.productGroup.refNo == groupCode || existingSubGroups.includes(f.refNo)));
    this.applyFilters();
  }

  applyFilters() {
    const filters = this.selectedFilters;

    // Toggle Clear All button
    filters.showClearAll =
      filters.cleatBtnPrice ||
      filters.flavours.length > 0 ||
      filters.foodTypes.length > 0 ||
      filters.offers.length > 0 ||
      filters.matrixGroups.length > 0 ||
      filters.groupSubGroups.length > 0;

    const hasActiveOfferFilter = filters.offers.length > 0;

    // If groupSubGroups or matrixGroups are active, ignore offer filtering strictly
    const ignoreStrictOfferFilter =
      filters.groupSubGroups.length > 0 || filters.matrixGroups.length > 0;

    this.productList = this.allProductList.filter(product => {
      const price = product.net_Sale_Price;
      const flavour = product.composition;
      const foodType = product.food_Type;
      const offerDetails = product.offerDetails ?? [];
      const productGroupRef = product.productSubGroup?.productGroup?.refNo;
      const subGroupRef = product.productSubGroup?.refNo;

      const matchesPrice =
        price >= filters.priceRange.min &&
        price <= filters.priceRange.max;

      const matchesFlavour =
        filters.flavours.length === 0 ||
        filters.flavours.includes(flavour);

      const matchesFoodType =
        filters.foodTypes.length === 0 ||
        filters.foodTypes.includes(foodType);

      const matchesOffer =
        !hasActiveOfferFilter ||
        ignoreStrictOfferFilter ||
        offerDetails.some(offer =>
          filters.offers.includes(offer.schemeType)
        );

      const matchesMatrixGroup =
        filters.matrixGroups.length === 0 ||
        filters.matrixGroups.includes(productGroupRef);

      const matchesGroupSubGroup =
        filters.groupSubGroups.length === 0 ||
        filters.groupSubGroups.some(sub => sub.refNo === subGroupRef);

      return (
        matchesPrice &&
        matchesFlavour &&
        matchesFoodType &&
        matchesOffer &&
        matchesMatrixGroup &&
        matchesGroupSubGroup
      );
    });

    // Save to localStorage
    this.localStorage.setItem('filterProductItems', JSON.stringify(filters));
  }


  toggleSection(section: string): void {
    this.isCollapsed[section] = !this.isCollapsed[section];
  }

  removeSubGroupFilter(subGroupCode: number): void {
    // Remove the selected subgroup
    this.selectedFilters.groupSubGroups = this.selectedFilters.groupSubGroups.filter(
      group => group.refNo !== subGroupCode
    );

    // Get unique group refNos from remaining subgroups
    const updatedMatrixGroups = this.selectedFilters.groupSubGroups.map(
      sub => sub.productGroup.refNo
    );

    // Retain only matrixGroups that match remaining subgroups
    this.selectedFilters.matrixGroups = this.selectedFilters.matrixGroups.filter(
      groupRef => updatedMatrixGroups.includes(groupRef)
    );

    // Apply updated filters
    this.applyFilters();
  }


  updateGroupCheckboxes(): void {
    // Create a set to hold groups with remaining subgroups
    const updatedMatrixGroups = new Set<number>();

    // Iterate over each matrix and group list
    this.matrixList.forEach(matrix => {
      matrix.groupList.forEach(group => {
        // If any subgroup in selectedFilters is part of this group, add it to the set
        if (this.selectedFilters.groupSubGroups.some(subGroup => subGroup.productGroup.refNo === group.refNo)) {
          updatedMatrixGroups.add(group.refNo);
        }
      });
    });

    // Update the selected matrix groups
    this.selectedFilters.matrixGroups = Array.from(updatedMatrixGroups);
  }

  isFilterChecked(type: string, value: any) {
    return this.selectedFilters[type].includes(value);
  }

  clearAllFilters(): void {
    this.selectedFilters = {
      priceRange: { min: 0, max: 1000 },
      flavours: [],
      foodTypes: [],
      offers: [],
      matrixGroups: [],
      groupSubGroups: [],
      showClearAll: false,
      cleatBtnPrice: false
    };
    this.selectedFilters.cleatBtnPrice = false;
    this.searchForm.patchValue({ minValue: this.min, maxValue: this.max });
    this.selectedFilters.priceRange = { min: this.min, max: this.max };
    this.applyFilters();
    this.expandAndCollapseAllFilters();
  }

  sortProducts(criteria: string) {
    this.activeSort = criteria;
    if (criteria === 'lowToHigh') {
      this.productList.sort((a, b) => a.net_Sale_Price - b.net_Sale_Price);
    } else if (criteria === 'highToLow') {
      this.productList.sort((a, b) => b.net_Sale_Price - a.net_Sale_Price);
    } else if (criteria === 'recommended') {
      // Implement your recommended sorting logic here
    }
    const sortData = [];
    this.productList.forEach(e => {
      sortData.push(e)
    })
    this.productList = sortData;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.viewport.checkViewportSize();
  }

  getProductDeliveryTimeAndStockDetails(): Promise<void> {
    return new Promise((resolve, reject) => {
      const deliveryType = JSON.parse(this.localStorage.getItem("delivery_type")) ?? 'delivery';
      const apiUrl = deliveryType === 'storePickup' ? this.apiFactory.getStoreMinimumDateTimeDetails : this.apiFactory.getWebOrderMinimumDateTimeDetails;
      const locId = JSON.parse(this.localStorage.getItem('location_code'));
      const minLocId = deliveryType === 'storePickup' ? locId : null;

      this.productService.getMinimumDateTimeDetails(apiUrl, this.currentUrl, minLocId).subscribe((data) => {
        if (data) {
          this.webOrderMinimumDateTimeList.deliveryTime = deliveryType === 'storePickup' ? data?.minOrderTime : data.deliveryTime;
          this.webOrderMinimumDateTimeList.maxDeliveryTime = deliveryType === 'storePickup' ? data?.maxOrderTime : data.maxDeliveryTime;

          const slotApiUrl = deliveryType === 'storePickup' ? this.apiFactory.getTimeSlotDetailsByUrlAndLocId : this.apiFactory.getTimeSlotDetailsByUrl;
          const slotLocId = deliveryType === 'storePickup' ? locId : null;

          this.productService.getTimeSlotList(slotApiUrl, this.currentUrl, slotLocId).subscribe((slotData) => {
            this.timeSlot2 = slotData.map((element) => [element.fromTime, element.toTime]);
            this.timeSlotAvl = this.timeSlot2.map(([fromTime, toTime]) => `${fromTime}-${toTime}`);

            var orderDuration = new Date();
            orderDuration.setHours(orderDuration.getHours() + Number.parseInt(this.webOrderMinimumDateTimeList?.deliveryTime?.split(":")[0]));
            orderDuration.setMinutes(orderDuration.getMinutes() + Number.parseInt(this.webOrderMinimumDateTimeList?.deliveryTime?.split(":")[1]));

            let maxOrderDuration = moment().add(Number(this.webOrderMinimumDateTimeList?.maxDeliveryTime?.split(":")[0]), "hours")
              .add(Number(this.webOrderMinimumDateTimeList?.maxDeliveryTime?.split(":")[1]), "minutes");

            // FETCH ALL STOCK DATA IN ONE CALL
            const productCodes = this.allProductList.map(p => p.product_Code);
            this.productService.getSystemAndManualStockDetails(this.apiFactory.getSystemAndManualStockDetails, locId ?? 0, productCodes, this.currentUrl, deliveryType)
              .subscribe((stockList: WebOrderStockDetailsDto[]) => {

                this.allProductList.forEach((product) => {
                  const stockData = stockList.find(stock => stock.productCode === product.product_Code);
                  const minQty = product.minimum_Order_Quantity || 0;

                  let isAvailable = true; // Default to available

                  if (stockData) {
                    if (stockData.manualStockAllow) {
                      // Check manual stock only
                      if (stockData.manualStock < minQty) {
                        isAvailable = false;
                      } else {
                        isAvailable = true;
                      }
                    } else if (stockData.systemStockAllow) {
                      // Manual not allowed, check system stock
                      if (stockData.systemStock < minQty) {
                        isAvailable = false;
                      } else {
                        isAvailable = true;
                      }
                    }
                    // If neither manual/system allow: keep isAvailable = true
                  }

                  product.outOfStock = !isAvailable;     // For blur + out of stock UI
                  product.stockAvailable = isAvailable;  // For disabling Add to Cart

                  // DELIVERY DATE + TIMESLOT LOGIC (same as before)
                  let minOrderDate = new Date();
                  minOrderDate.setDate(minOrderDate.getDate() + product.minimum_Order_Time);

                  let greaterDate = orderDuration > minOrderDate ? orderDuration : minOrderDate;
                  let todayDate = moment(greaterDate);

                  product.deliveryDate = todayDate.format("YYYY-MM-DD");
                  product.defaultDate = todayDate.format("YYYY-MM-DD");
                  product.deliveryTime = todayDate.format("HH:mm");
                  product.maxDeliveryDate = maxOrderDuration.format("YYYY-MM-DD");
                  product.maxDeliveryTime = maxOrderDuration.format("HH:mm");

                  let totTime = todayDate.hours() * 60 + todayDate.minutes();
                  product.timeSlotAvl = [];
                  let matchedSlot = false;

                  for (const e of this.timeSlot2) {
                    let fromSlotTime = Number(e[0].split(":")[0]) * 60 + Number(e[0].split(":")[1]);
                    if (totTime < fromSlotTime) {
                      let tSlot = `${e[0]}-${e[1]}`;
                      product.timeSlotAvl.push(tSlot);
                      if (!matchedSlot) {
                        product.deliveryTime = tSlot;
                        matchedSlot = true;
                      }
                    }
                  }

                  if (!matchedSlot) {
                    todayDate = todayDate.clone().add(1, 'day');
                    product.deliveryDate = todayDate.format("YYYY-MM-DD");
                    product.timeSlotAvl = this.timeSlot2.map(slot => `${slot[0]}-${slot[1]}`);
                    product.deliveryTime = product.timeSlotAvl[0];
                  }

                  const today = moment().startOf('day');
                  const deliveryDay = todayDate.clone().startOf('day');

                  if (deliveryDay.isSame(today, 'day')) {
                    product.deliveryLabel = 'Today';
                  } else if (deliveryDay.diff(today, 'days') === 1) {
                    product.deliveryLabel = 'Tomorrow';
                  } else {
                    product.deliveryLabel = deliveryDay.format('Do MMM');
                  }
                });
                console.log(this.productList);
                resolve();
              }, reject);
          }, reject);
        } else {
          reject("Invalid delivery data");
        }
      }, reject);
    });
  }

  onMinSliderChange(event: any) {
    const value = Number(event.target.value);

    this.searchForm.get('minValue')?.setValue(value, { emitEvent: false });

    if (value > this.searchForm.get('maxValue')?.value) {
      this.searchForm.get('maxValue')?.setValue(value);
    }
  }

  onMaxSliderChange(event: any) {
    const value = Number(event.target.value);

    this.searchForm.get('maxValue')?.setValue(value, { emitEvent: false });

    if (value < this.searchForm.get('minValue')?.value) {
      this.searchForm.get('minValue')?.setValue(value);
    }
  }

  globalMin: number = 0;
  globalMax: number = 50000; // change dynamically

  setGlobalMinMax() {
    this.globalMin = this.searchForm.get('minValue')?.value;
    this.globalMax = this.searchForm.get('maxValue')?.value;
  }

  generateSlug(name: string): string {
    return name
      .toLowerCase()
      .replace(/[^a-z0-9 ]/g, '')
      .replace(/\s+/g, '-');
  }

  cacheBuster = Date.now();
  getImageUrl(imageName: string): string {
    return 'assets/img/' + imageName + '?ud=' + this.cacheBuster;
  }

  onImageError(event: any) {
    event.target.src = 'assets/img/defaultCake.webp';
  }
}
